import { useHasPermission } from 'helpers/global.helper/global.helper'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import View from 'ui/components/View/View'
import { DayAheadTradingUnderConstructionBanner } from './components/DayAheadTradingUnderConstructionBanner'
import styles from './DayAheadTradingPrototype.module.less'

export function DayAheadTradingPrototype(): ReactNode {
  const { t } = useTranslation()
  const hasDayAheadTradingPrototypeAccess = useHasPermission('view_day_ahead_trading_prototype')

  return (
    <div className={styles.DayAheadTradingPrototype}>
      <View
        stickyHeader
        header={<ModuleHeader infoHeader={t('Day Ahead Trading (Prototype)')} includePropertyFilter={false} />}
      >
        {hasDayAheadTradingPrototypeAccess ? (
          <DayAheadTradingUnderConstructionBanner />
        ) : (
          <div>{t('Unfortunately, you do not have permission to view this page')}</div>
        )}
      </View>
    </div>
  )
}
